import { useState, useEffect } from 'react'
import { api, getErrorMessage } from '@/shared/api/generated'
import type { ActiveSession } from '@/shared/api/generated'
import { toast } from '@/shared/stores/toastStore'

export function MySessions() {
  const [sessions, setSessions] = useState<ActiveSession[]>([])
  const [loading, setLoading] = useState(true)

  const load = () => {
    api.listSessions().then(setSessions).catch(() => {}).finally(() => setLoading(false))
  }

  useEffect(load, [])

  const revoke = async (prefix: string) => {
    try {
      await api.revokeSession(prefix)
      toast.info('Session revoked')
      load()
    } catch (err) {
      toast.error(getErrorMessage(err))
    }
  }

  if (loading) return null

  return (
    <div data-testid="my-sessions">
      <h3>Active Sessions</h3>
      {sessions.length === 0 ? (
        <p className="muted">No active sessions</p>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>IP Address</th>
              <th>Created</th>
              <th>2FA</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sessions.map(s => (
              <tr key={s.token_prefix} className={s.current ? 'current-session' : ''}>
                <td>{s.ip_address}{s.current && <span className="badge-current"> (current)</span>}</td>
                <td>{new Date(s.created_at).toLocaleString()}</td>
                <td>{s.totp_verified ? '✓' : '—'}</td>
                <td>
                  {!s.current && (
                    <button className="btn-outline-danger btn-sm" onClick={() => revoke(s.token_prefix)}>Revoke</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
